import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Plan } from '@qaroni-app/payments/types/plan';
import { PlanNameEnum } from '@qaroni-app/payments/types/plan-name.enum';

@Component({
  selector: 'qaroni-payments-level-container',
  templateUrl: './payments-level-container.component.html',
  styleUrls: ['./payments-level-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PaymentsLevelContainerComponent {
  readonly isMonthly = input<boolean>(true);
  readonly plans = input<Plan[]>([]);

  get starterPlan(): Plan {
    return this.plans()?.filter(plan => plan.name === PlanNameEnum.STARTER)[0];
  }

  get startupPlan(): Plan {
    return this.plans()?.filter(plan => plan.name === PlanNameEnum.STARTUP)[0];
  }

  get businessPlan(): Plan {
    return this.plans()?.filter(plan => plan.name === PlanNameEnum.BUSINESS)[0];
  }
}
